import Vue from 'vue'
import Vuex from 'vuex'
//import { navigationLinks } from '../components/navigation/sidebar/navigation-links';

const { merge, keyBy, values } = require('lodash');

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    host: {},
    newGuests: []
    //navigation: navigationLinks
  },
  mutations: {
    set(state, host) {
      state.host = Object.assign({}, state.host, host)
    },
    update(state, host) {
      state.host = Object.assign({}, state.host, host)
    },
    setGuests(state) {
      fetch(process.env.VUE_APP_API + '/notifications/guests', {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          "CSRF-Token": this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        state.newGuests = response;
      })
    },
    changeGuests(state, index, value) {
      if(state.newGuests.find(g => g._id == index)){
        state.newGuests.find(g => g._id == index).newGuests += value;
      }
    }
  },
  actions: {
    async set({commit}){
      let session = $cookies.get('session');
      if(session){
        const base64Host = session.split('.')[1];
        const decoded = JSON.parse(Buffer(base64Host, 'base64').toString('utf8'));

        let host = decoded.host;

        /*if(host.properties.length){
          let response = await fetch(process.env.VUE_APP_API + '/properties?' + host.properties.map(p => "propertyId[]=" + p._id).join('&'), {
            method: 'get',
            credentials: 'include',
            headers: {
              "Content-type": "application/json",
              "Accept": "application/json",
              "Accept-Charset": "utf-8",
              'CSRF-Token': Vue.prototype.$csrf
            }
          });
          let properties = await response.json();

          host.properties = values(merge(keyBy(host.properties, '_id'), keyBy(properties, '_id')));
        }*/

        let response = await fetch(process.env.VUE_APP_API + "/properties?host._id[]=" + host._id, {
          method: 'get',
          credentials: 'include',
          headers: {
            "Content-type": "application/json",
            "Accept": "application/json",
            "Accept-Charset": "utf-8",
            'CSRF-Token': Vue.prototype.$csrf
          }
        });
        let properties = await response.json();

        host.properties = properties;

        commit('set', host);
      }else{
        commit('set', {});
      }
    },


  },
  getters: {
    host: state => state.host
  },
})
